import { FlashMessage } from '../../model/flash-message.types';

export interface FlashMessagesState {
  flashMessages: FlashMessage[];
}

export const initialFlashMessagesState: FlashMessagesState = {
  flashMessages: [],
};
